import React, { Component } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import ExportButton from '../../Layouts/ExportButton';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { DataGrid } from '@mui/x-data-grid';
import AuthApi from '../../Services/Authapi';
import ls from "local-storage";
import Chart from "chart.js/auto";
import "./Attendance.css";
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Grid } from '@material-ui/core';
import logo from './logo.png';
import TooltipCell from '../../TooltipCell';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import FilterListIcon from '@material-ui/icons/FilterList';
import jsPDF from 'jspdf'

import autoTable from 'jspdf-autotable';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import { useTheme } from '@material-ui/core/styles';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div style={{ flexShrink: 0, marginLeft: theme.spacing(2.5) }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}
 
class Attendance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Attendance: [],
            dailyLogData: [],
            searchQueryMonthly: "",
            searchQueryDaily: "",
            suggestionsMonthly: [],
            suggestionsDaily: [],
            selectedDate: new Date().toISOString().split('T')[0].slice(0, 7),
            selectedDatejh: new Date().toISOString().split('T')[0],
            showMonthlyLog: false,
            pageSizeMonthly: 5,
            pageSizeDaily: 5,
            pageMonthly: 0,
            pageDaily: 0,
            statusColors: {},
            userStatistics: [],
            modalUserStatistics: [],
            columns: [
                {
                    field: 'user_name', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'firstname', headerName: 'Name', flex: 1, headerClassName: 'header-red',
                    align: 'left', headerAlign: 'left',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div>
                },
                {
                    field: 'date', headerName: 'Date', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'status',
                    headerName: 'Status',
                    flex: 1,
                    headerClassName: 'header-red',
                    renderCell: (params) => {
                        let statusText = params.value;
                        if (statusText === 'Comes Late') {
                            statusText = 'Late';
                        }
                        let bgColor = this.state.statusColors[statusText] || '#1ac0deff'; // fallback black
                        if (statusText === 'Overtime') {
                            bgColor = '#00bcd4'; // Teal/Cyan but distinct enough? 
                        }
                        return (
                            <div
                                style={{
                                    backgroundColor: statusText === 'Overtime' ? '#b86e00' : bgColor,
                                    color: 'black',
                                    width: '140px',
                                    height: '28px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '4px',
                                    fontWeight: 'bold',
                                    fontSize: '12px',
                                    textAlign: 'center'
                                }}
                            >
                                {statusText}
                            </div>
                        );
                    }
                },  
                {
                    field: 'first_in_time', headerName: 'First In Time', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'last_out_time', headerName: 'Last Out Time', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'total_duration', headerName: 'Total Duration', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'break_duration', headerName: 'Break Duration', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'breaks', headerName: 'Breaks', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
            ],
            dailyLogColumns: [
                {
                    field: 'serial_no', headerName: 'Serial No', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'user_name', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'firstname', headerName: 'Name', flex: 1, headerClassName: 'header-red',
                    align: 'left', headerAlign: 'left',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div>
                },
                {
                    field: 'date', headerName: 'Date', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'time', headerName: 'Time', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
                {
                    field: 'type',
                    headerName: 'Type',
                    flex: 1,
                    headerClassName: 'header-red',
                    renderCell: (params) => {

                        if (params.value === 'IN') {
                            return (
                                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>IN</span>
                                </div>
                            );
                        }
                        if (params.value === 'OUT') {
                            return (
                                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
                                    <span style={{ color: 'red', fontWeight: 'bold' }}>OUT</span>
                                </div>
                            );
                        }
                        if (params.value && params.value.startsWith('IN / Comes Late')) {
                            const color = this.state.statusColors && this.state.statusColors['Late']
                                ? this.state.statusColors['Late']
                                : '#000000';
                            return (
                                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>
                                    <span>
                                        <span style={{ color: 'green', fontWeight: 'bold' }}>IN / </span>
                                        <span style={{ color, fontWeight: 'bold' }}>Late</span>
                                    </span>
                                </div>
                            );
                        }
                        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>;
                    }
                },
                {
                    field: 'duration', headerName: 'Duration', flex: 1, headerClassName: 'header-red',
                    renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div>
                },
            ],
            selectedUser: "",
            isUserStatsOpen: false,
            modalSelectedUser: "",
            modalSelectedMonthYear: "",
            modalAttendance: [],
        };
        this.chartRef = React.createRef();
        this.handleChangeMonthly = this.handleChangeMonthly.bind(this);
        this.handleChangeDaily = this.handleChangeDaily.bind(this);
        this.handleSearchMonthly = this.handleSearchMonthly.bind(this);
        this.handleSearchDaily = this.handleSearchDaily.bind(this);
        this.clearSearchMonthly = this.clearSearchMonthly.bind(this);
        this.clearSearchDaily = this.clearSearchDaily.bind(this);
        this.handleSuggestionClickMonthly = this.handleSuggestionClickMonthly.bind(this);
        this.handleSuggestionClickDaily = this.handleSuggestionClickDaily.bind(this);
        this.handlePageSizeChangeMonthly = this.handlePageSizeChangeMonthly.bind(this);
        this.handlePageSizeChangeDaily = this.handlePageSizeChangeDaily.bind(this);
        this.handleUserChange = this.handleUserChange.bind(this);
    }

    // Returns current month in YYYY-MM so month pickers cannot go to the future
    getCurrentMonth = () => new Date().toISOString().split('T')[0].slice(0, 7);

    // Clamp any selected month to not exceed the current month
    clampToCurrentMonth = (value) => {
        const maxMonth = this.getCurrentMonth();
        if (value && value > maxMonth) {
            return maxMonth;
        }
        return value;
    };

    handlePageChangeMonthly = (event, newPage) => {
        this.setState({ pageMonthly: newPage });
    };

    handlePageChangeDaily = (event, newPage) => {
        this.setState({ pageDaily: newPage });
    };

    componentDidMount() {
        // if (!this.props.authToken) {
        //     this.props.history.push("/login");
        //     return;
        // }
        this.fetchData();
        this.fetchDailyLog();
        AuthApi.getStatusColors().then((response) => {
            if (response && response.status && response.data) {
                const fetchedColors = response.data;
                if (fetchedColors['Comes Late'] && !fetchedColors['Late']) {
                    fetchedColors['Late'] = fetchedColors['Comes Late'];
                }
                this.setState({ statusColors: fetchedColors });
            } else {
                this.setState({ statusColors: {} });
            }
        });

        // Listen for theme changes
        this.themeObserver = new MutationObserver(() => {
            if (!this.state.showMonthlyLog && this.chartInstance) {
                this.createChart();
            }
        });

        this.themeObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme']
        });

        this.themeObserverBody = new MutationObserver(() => {
            if (!this.state.showMonthlyLog && this.chartInstance) {
                this.createChart();
            }
        });

        this.themeObserverBody.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    componentWillUnmount() {
        if (this.themeObserver) {
            this.themeObserver.disconnect();
        }
        if (this.themeObserverBody) {
            this.themeObserverBody.disconnect();
        }
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
    }

    fetchData = async () => {
        const { selectedDate } = this.state;
        const [year, month] = selectedDate.split('-');
        try {
            const roles = ls.get("roles");
            const isPrivileged = roles && (roles.includes("Super Admin") || roles.includes("Admin"));
            let response;

            let workingHoursData = null;
            try {
                const whRes = await AuthApi.getWorkingHours();
                if (whRes && whRes.data) {
                    workingHoursData = whRes.data;
                }
            } catch (err) {
                console.error("Error fetching working hours:", err);
            }

            if (isPrivileged) {
                response = await AuthApi.getallAttendance(month, year);
            } else {
                response = await AuthApi.getAttendance(ls.get("user").id, month, year);
            }
            if (response && response.status === true) {
                const earlyLeaveMinHrs = workingHoursData && workingHoursData.early_leave_min_hours ? parseFloat(workingHoursData.early_leave_min_hours) : null;
                const earlyLeaveAllowedDays = workingHoursData && workingHoursData.early_leave_allowed_days ? parseInt(workingHoursData.early_leave_allowed_days, 10) : null;
                const fullDayHours = workingHoursData && workingHoursData.full_day_hours ? parseFloat(workingHoursData.full_day_hours) : 8;

                const sortedData = [...response.data].sort((a, b) => {
                    const dateA = a.date ? a.date.split('-').reverse().join('-') : '';
                    const dateB = b.date ? b.date.split('-').reverse().join('-') : '';
                    return new Date(dateA) - new Date(dateB);
                });

                const earlyLeaveCountMap = {};

                let attendanceData = sortedData.map((row, index) => {
                    let status = row.status;
                    const workSeconds = this.parseDurationToSeconds(row.total_duration);
                    
                    if (status && status.toLowerCase().includes('present')) {
                        if (workSeconds > 9 * 3600) { // 9 hours in seconds
                            status = "Overtime";
                        }
                    }

                    if (status && !['absent', 'leave', 'week off', 'holiday'].includes(status.toLowerCase()) && workSeconds > 0 && earlyLeaveMinHrs != null && !isNaN(earlyLeaveMinHrs) && earlyLeaveAllowedDays != null && !isNaN(earlyLeaveAllowedDays) && fullDayHours != null && !isNaN(fullDayHours)) {
                        const minHrsSeconds = earlyLeaveMinHrs * 3600;
                        const fullHrsSeconds = fullDayHours * 3600;

                        if (workSeconds >= minHrsSeconds && workSeconds < fullHrsSeconds) {
                            const employeeId = row.user_name || row.firstname;
                            if (!earlyLeaveCountMap[employeeId]) {
                                earlyLeaveCountMap[employeeId] = 0;
                            }
                            earlyLeaveCountMap[employeeId]++;

                            if (earlyLeaveCountMap[employeeId] <= earlyLeaveAllowedDays) {
                                status = "Left Early";
                            } else {
                                status = "Half Day";
                            }
                        }
                    }

                    return {
                        id: index + 1,
                        ...row,
                        status: status
                    };
                });
                
                attendanceData.sort((a, b) => {
                    const dateA = a.date ? a.date.split('-').reverse().join('-') : ''; 
                    const dateB = b.date ? b.date.split('-').reverse().join('-') : '';
                    return new Date(dateB) - new Date(dateA);
                });

                attendanceData = attendanceData.map((row, index) => ({
                    ...row,
                    id: index + 1
                }));

                this.setState({
                    Attendance: attendanceData,
                    userStatistics: response.user_statistics || [], // Store user statistics
                }, () => {
                    // Auto-select logged-in user for monthly filter on standard users
                    if (!isPrivileged) {
                        const defaultUser = (attendanceData && attendanceData[0] && attendanceData[0].firstname) ? attendanceData[0].firstname : '';
                        if (defaultUser && this.state.selectedUser !== defaultUser) {
                            this.setState({ selectedUser: defaultUser }, this.filterBySelectedUser);
                        } else if (this.state.selectedUser) {
                            // If a user is already selected, apply the filter to new data
                            this.filterBySelectedUser();
                        } else {
                            // If no user selected, show all data
                            this.setState({ filterEvents: attendanceData });
                        }
                    } else {
                        // For Admin/Super Admin, if a user is selected, apply the filter
                        if (this.state.selectedUser) {
                            this.filterBySelectedUser();
                        } else {
                            // If no user selected, show all data
                            this.setState({ filterEvents: attendanceData });
                        }
                    }
                });
            } else {
                console.error("Failed to fetch attendance data:", response.message);
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    };


    fetchDailyLog = async (id) => {
        const { selectedDatejh } = this.state;
        const [year, month, day] = selectedDatejh.split('-');
        try {
            const roles = ls.get("roles");
            let response;

            if (roles && roles.includes("Super Admin")) {
                response = await AuthApi.getalldatadailylog(day, month, year);
            } else {
                response = await AuthApi.getdailylog(ls.get("user").id, day, month, year);
            }

            if (response && response.status === true) {
                const dailyLogData = response.data.map((row, index) => ({
                    id: index + 1,
                    // serial_no: index + 1,
                    ...row
                }));
                this.setState({
                    dailyLogData: dailyLogData,
                }, this.createChart);
            } else {
                console.error("Failed to fetch daily log data:", response.message);
            }
        } catch (error) {
            console.error("Error fetching daily log data:", error);
        }
    };



    handleShowDailyLog = () => {
        this.setState({ showMonthlyLog: false }, () => {
            this.fetchDailyLog(ls.get("user").id);
        });
    };

    handleDateChange = (event) => {
        const selectedDate = this.clampToCurrentMonth(event.target.value);
        this.setState({ selectedDate }, () => {
            this.fetchData();
        });
    };

    handleModalMonthChange = (event) => {
        const modalSelectedMonthYear = this.clampToCurrentMonth(event.target.value);
        this.setState({ modalSelectedMonthYear }, this.fetchModalAttendance);
    };

    handledayChange = (event) => {
        const selectedDatejh = event.target.value;
        this.setState({ selectedDatejh }, this.fetchDailyLog);
    };

    handleShowMonthlyLog = () => {
        if (this.chartInstance) {
            this.chartInstance.destroy();
            this.chartInstance = null;
        }
        this.setState({ showMonthlyLog: true });
    };







    createChart = () => {
        const { dailyLogData } = this.state;
        const canvas = this.chartRef ? this.chartRef.current : null;
        if (!canvas) {
            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }
            return;
        }
        if (!Array.isArray(dailyLogData) || dailyLogData.length === 0) {
            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }
            return;
        }
        const userLogs = {};
        const inToOutData = [];
        const breakData = [];

        dailyLogData.forEach(log => {
            const timeParts = log.time.split(':');
            const hours = parseInt(timeParts[0], 10);
            const minutes = parseInt(timeParts[1], 10);
            const seconds = parseInt(timeParts[2].split(' ')[0], 10);
            const period = timeParts[2].split(' ')[1];
            let timeIn24HourFormat = hours;
            if (period === 'PM' && hours !== 12) {
                timeIn24HourFormat += 12;
            } else if (period === 'AM' && hours === 12) {
                timeIn24HourFormat = 0;
            }
            const timeInHours = timeIn24HourFormat + minutes / 60 + seconds / 3600;
            if (!userLogs[log.firstname]) {
                userLogs[log.firstname] = [];
            }
            userLogs[log.firstname].push({
                time: timeInHours,
                type: log.type
            });
        });

        Object.keys(userLogs).forEach(userName => {
            const logs = userLogs[userName];
            for (let i = 0; i < logs.length - 1; i++) {
                const currentLog = logs[i];
                const nextLog = logs[i + 1];
                if (currentLog.type === 'IN' && nextLog.type === 'OUT') {
                    inToOutData.push({
                        x: [currentLog.time, nextLog.time],
                        y: userName
                    });
                } else if (currentLog.type === 'OUT' && nextLog.type === 'IN') {
                    breakData.push({
                        x: [currentLog.time, nextLog.time],
                        y: userName
                    });
                }
            }
        });

        if (this.chartInstance) {
            this.chartInstance.destroy();
        }

        // Detect dark mode
        const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark' ||
            document.body.classList.contains('dark-theme');
        const textColor = isDarkMode ? '#ffffff' : '#000000';
        const gridColor = isDarkMode ? '#4a4a4a' : '#e0e0e0';

        const ctx = canvas.getContext("2d");
        this.chartInstance = new Chart(ctx, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: 'IN & OUT',
                        data: inToOutData,
                        backgroundColor: 'rgba(54, 162, 235, 0.6)',
                        borderColor: 'rgba(54, 162, 235, 1)',
                        borderWidth: 2,
                        barThickness: 10,
                        borderSkipped: false
                    },
                    {
                        label: 'BREAKS',
                        data: breakData,
                        backgroundColor: 'rgba(255, 99, 132, 0.6)',
                        borderColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 2,
                        barThickness: 10,
                        borderSkipped: false
                    }
                ]
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        type: 'linear',
                        position: 'bottom',
                        min: 9,
                        max: 21,
                        ticks: {
                            stepSize: 1,
                            color: textColor,
                            callback: function (value) {
                                const hour = Math.floor(value);
                                const period = hour >= 12 ? 'PM' : 'AM';
                                const hour12 = hour % 12 || 12;
                                return `${hour12}:00 ${period}`;
                            }
                        },
                        grid: {
                            color: gridColor
                        }
                    },
                    y: {
                        type: 'category',
                        labels: Object.keys(userLogs),
                        ticks: {
                            color: textColor
                        },
                        grid: {
                            color: gridColor
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: {
                            color: textColor,
                            font: {
                                weight: 'bold',
                                size: 12
                            },
                            generateLabels: function (chart) {
                                const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark' ||
                                    document.body.classList.contains('dark-theme');
                                const labelColor = isDarkMode ? '#ffffff' : '#000000';
                                return [
                                    {
                                        text: 'IN & OUT',
                                        fillStyle: 'rgba(54, 162, 235, 0.6)',
                                        strokeStyle: 'rgba(54, 162, 235, 1)',
                                        lineWidth: 1,
                                        fontColor: labelColor
                                    },
                                    {
                                        text: 'BREAKS',
                                        fillStyle: 'rgba(255, 99, 132, 0.6)',
                                        strokeStyle: 'rgba(255, 99, 132, 1)',
                                        lineWidth: 1,
                                        fontColor: labelColor
                                    }
                                ];
                            }
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.dataset.label || '';
                                const value = context.raw.x;
                                const startTime = value[0];
                                const endTime = value[1];

                                const formatTime = (time) => {
                                    const hour = Math.floor(time);
                                    const minute = Math.floor((time % 1) * 60);
                                    const period = hour >= 12 ? 'PM' : 'AM';
                                    const hour12 = hour % 12 || 12;
                                    return `${hour12}:${minute < 10 ? '0' : ''}${minute} ${period}`;
                                };

                                return `${label}: ${formatTime(startTime)} - ${formatTime(endTime)}`;
                            }
                        }
                    }
                }
            }
        });
    };

    // Helpers for user stats modal
    openUserStatsModal = () => {
        const { selectedUser, selectedDate, Attendance } = this.state;
        const roles = ls.get("roles");
        const isSuperAdmin = roles && roles.includes("Super Admin");
        let modalUser = selectedUser || "";
        if (!isSuperAdmin) {
            // For non-super admins, Attendance contains only their rows. Use the exact name string from data
            const row = Array.isArray(Attendance) && Attendance.length > 0 ? Attendance[0] : null;
            modalUser = (row && row.firstname) ? row.firstname : modalUser;
        }
        this.setState({ isUserStatsOpen: true, modalSelectedUser: modalUser, modalSelectedMonthYear: selectedDate, modalAttendance: [] }, this.fetchModalAttendance);
    };

    closeUserStatsModal = () => {
        this.setState({ isUserStatsOpen: false });
    };

    fetchModalAttendance = async () => {
        const { modalSelectedMonthYear } = this.state;
        if (!modalSelectedMonthYear) return;
        const [year, month] = modalSelectedMonthYear.split('-');
        try {
            const roles = ls.get("roles");
            let response;
            
            let workingHoursData = null;
            try {
                const whRes = await AuthApi.getWorkingHours();
                if (whRes && whRes.data) {
                    workingHoursData = whRes.data;
                }
            } catch (err) {
                console.error("Error fetching working hours:", err);
            }

            if (roles && (roles.includes("Super Admin") || roles.includes("Admin"))) {
                response = await AuthApi.getallAttendance(month, year);
            } else {
                response = await AuthApi.getAttendance(ls.get("user").id, month, year);
            }
            if (response && response.status === true) {
                const earlyLeaveMinHrs = workingHoursData && workingHoursData.early_leave_min_hours ? parseFloat(workingHoursData.early_leave_min_hours) : null;
                const earlyLeaveAllowedDays = workingHoursData && workingHoursData.early_leave_allowed_days ? parseInt(workingHoursData.early_leave_allowed_days, 10) : null;
                const fullDayHours = workingHoursData && workingHoursData.full_day_hours ? parseFloat(workingHoursData.full_day_hours) : 8;

                const sortedData = [...response.data].sort((a, b) => {
                    const dateA = a.date ? a.date.split('-').reverse().join('-') : '';
                    const dateB = b.date ? b.date.split('-').reverse().join('-') : '';
                    return new Date(dateA) - new Date(dateB);
                });

                const earlyLeaveCountMap = {};

                let attendanceData = sortedData.map((row, index) => {
                    let status = row.status;
                    const workSeconds = this.parseDurationToSeconds(row.total_duration);
                    
                    if (status && status.toLowerCase().includes('present')) {
                        if (workSeconds > 9 * 3600) { // 9 hours in seconds
                            status = "Overtime";
                        }
                    }

                    if (status && !['absent', 'leave', 'week off', 'holiday'].includes(status.toLowerCase()) && workSeconds > 0 && earlyLeaveMinHrs != null && !isNaN(earlyLeaveMinHrs) && earlyLeaveAllowedDays != null && !isNaN(earlyLeaveAllowedDays) && fullDayHours != null && !isNaN(fullDayHours)) {
                        const minHrsSeconds = earlyLeaveMinHrs * 3600;
                        const fullHrsSeconds = fullDayHours * 3600;

                        if (workSeconds >= minHrsSeconds && workSeconds < fullHrsSeconds) {
                            const employeeId = row.user_name || row.firstname;
                            if (!earlyLeaveCountMap[employeeId]) {
                                earlyLeaveCountMap[employeeId] = 0;
                            }
                            earlyLeaveCountMap[employeeId]++;

                            if (earlyLeaveCountMap[employeeId] <= earlyLeaveAllowedDays) {
                                status = "Left Early";
                            } else {
                                status = "Half Day";
                            }
                        }
                    }

                    return {
                        id: index + 1,
                        ...row,
                        status: status
                    };
                });
                
                attendanceData.sort((a, b) => {
                    const dateA = a.date ? a.date.split('-').reverse().join('-') : ''; 
                    const dateB = b.date ? b.date.split('-').reverse().join('-') : '';
                    return new Date(dateB) - new Date(dateA);
                });

                attendanceData = attendanceData.map((row, index) => ({
                    ...row,
                    id: index + 1
                }));

                this.setState({
                    modalAttendance: attendanceData,
                    modalUserStatistics: response.user_statistics || []
                });
            } else {
                this.setState({ modalAttendance: [], modalUserStatistics: [] });
            }
        } catch (e) {
            this.setState({ modalAttendance: [], modalUserStatistics: [] });
        }
    };

    handleModalUserChange = (event) => {
        this.setState({ modalSelectedUser: event.target.value });
    };

    parseDurationToSeconds = (value) => {
        if (!value || typeof value !== 'string') return 0;
        const sanitized = value.trim();
        if (!sanitized || sanitized.toLowerCase() === 'n/a' || sanitized === '-') return 0;
        const lower = sanitized.toLowerCase();
        // Textual forms like "10 hours 30 minutes", "8 hr", "45 mins", "10h 30m", etc.
        const hourMatch = lower.match(/(\d+(?:\.\d+)?)\s*(?:hours?|hrs?|hr|h)\b/);
        const minuteMatch = lower.match(/(\d+(?:\.\d+)?)\s*(?:minutes?|mins?|min|m)\b/);
        const secondMatch = lower.match(/(\d+(?:\.\d+)?)\s*(?:seconds?|secs?|sec|s)\b/);
        if (hourMatch || minuteMatch || secondMatch) {
            const hours = hourMatch ? parseFloat(hourMatch[1]) : 0;
            const minutes = minuteMatch ? parseFloat(minuteMatch[1]) : 0;
            const seconds = secondMatch ? parseFloat(secondMatch[1]) : 0;
            return Math.round(hours * 3600 + minutes * 60 + seconds);
        }
        // Colon-based format HH:MM:SS or MM:SS
        if (sanitized.includes(':')) {
            const parts = sanitized.split(':').map(p => parseInt(p, 10));
            if (parts.some(isNaN)) return 0;
            if (parts.length === 3) {
                const [h, m, s] = parts;
                return (h * 3600) + (m * 60) + s;
            }
            if (parts.length === 2) {
                const [m, s] = parts;
                return (m * 60) + s;
            }
        }
        // Fallback: treat single number as minutes
        const numeric = parseFloat(sanitized);
        if (!isNaN(numeric)) {
            return Math.round(numeric * 60);
        }
        return 0;
    };

    formatSecondsToHMS = (totalSeconds) => {
        const seconds = Math.max(0, Math.floor(totalSeconds));
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        const hh = String(h).padStart(2, '0');
        const mm = String(m).padStart(2, '0');
        const ss = String(s).padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
    };

    formatSecondsToHoursText = (totalSeconds) => {
        const seconds = Math.max(0, Math.floor(totalSeconds));
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        if (hours > 0 && minutes === 0) {
            return `${hours} hour${hours === 1 ? '' : 's'}`;
        }
        if (hours > 0) {
            return `${hours}h ${minutes}m`;
        }
        return `${minutes}m`;
    };

    computeUserMonthlyAndWeeklyTotals = () => {
        const { modalAttendance, Attendance, modalSelectedUser, selectedDate, modalSelectedMonthYear } = this.state;
        if (!modalSelectedUser) {
            return { monthly: { work: 0, break: 0 }, weekly: [], weeklyBreak: [], weeklyDays: [], weeklyWeekdayWork: [], sumWeeklyWork: 0, sumWeeklyBreak: 0, sumWeekdayWork: 0, weeklyDateRanges: [] };
        }
        const [selectedYear, selectedMonth] = (modalSelectedMonthYear || selectedDate).split('-');
        let monthlyWork = 0;
        let monthlyBreak = 0;
        let monthlyPresentDays = 0;
        const weeklyTotals = [];
        const weeklyBreakTotals = [];
        const weeklyDays = [];
        const weeklyWeekdayWork = [];
        const weeklyDateRanges = [];

        const firstDayOfMonth = new Date(selectedYear, selectedMonth - 1, 1);
        const lastDayOfMonth = new Date(selectedYear, selectedMonth, 0);
        const daysInMonth = lastDayOfMonth.getDate();
        const weeklyRanges = [];
        const firstDow = firstDayOfMonth.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
        const daysToFirstMonday = firstDow === 0 ? 1 : (8 - firstDow) % 7;
        const firstMonday = 1 + daysToFirstMonday;
        if (firstDow >= 1 && firstDow <= 5) {
            const firstWeekEnd = Math.min(1 + (5 - firstDow), daysInMonth);
            weeklyRanges.push({ start: 1, end: firstWeekEnd });
        }
        let currentMonday = (firstDow === 1) ? firstMonday + 7 : firstMonday;
        while (currentMonday <= daysInMonth) {
            const start = currentMonday;
            const end = Math.min(currentMonday + 4, daysInMonth);
            weeklyRanges.push({ start, end });
            currentMonday += 7;
        }
        if (weeklyRanges.length > 5) {
            weeklyRanges.length = 5;
        }
        for (let i = 0; i < weeklyRanges.length; i++) {
            weeklyTotals.push(0);
            weeklyBreakTotals.push(0);
            weeklyDays.push(0);
            weeklyWeekdayWork.push(0);
        }
        for (let i = 0; i < weeklyRanges.length; i++) {
            const { start, end } = weeklyRanges[i];
            const startDate = new Date(selectedYear, selectedMonth - 1, start);
            const endDate = new Date(selectedYear, selectedMonth - 1, end);
            const startFormatted = startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            const endFormatted = endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            weeklyDateRanges.push(start === end ? startFormatted : `${startFormatted} - ${endFormatted}`);
        }

        const source = modalSelectedMonthYear ? modalAttendance : Attendance;

        source.forEach(row => {
            if (!row || row.firstname !== modalSelectedUser) return;
            const dateStr = row.date || '';
            const parts = dateStr.split('-');
            if (parts.length !== 3) return;
            const day = parseInt(parts[0], 10);
            const month = parts[1];
            const year = parts[2];
            if (year !== selectedYear || month !== selectedMonth) return;

            const workSec = this.parseDurationToSeconds(row.total_duration);
            const breakSec = this.parseDurationToSeconds(row.break_duration);
            monthlyWork += workSec;
            monthlyBreak += breakSec;

            // Calculate which week this day belongs to using the precomputed ranges
            const currentDate = new Date(`${year}-${month}-${String(day).padStart(2, '0')}`);
            const dow = currentDate.getDay(); // 0=Sun, 1=Mon, ... 6=Sat
            let weekIndex = -1;
            if (dow >= 1 && dow <= 5) {
                weekIndex = weeklyRanges.findIndex(r => day >= r.start && day <= r.end);
            }

            if (weekIndex >= 0 && weekIndex < weeklyRanges.length) {
                weeklyTotals[weekIndex] += workSec;
                weeklyBreakTotals[weekIndex] += breakSec;

                // Count weekdays (Mon-Fri) and their work totals
                if (dow >= 1 && dow <= 5) {
                    if (workSec > 0) {
                        weeklyDays[weekIndex] += 1;
                    }
                    weeklyWeekdayWork[weekIndex] += workSec;
                }
            }

            // Monthly present day counting (status has 'present' or any positive workSec)
            const statusLower = (row.status || '').toLowerCase();
            const isPresent = statusLower.includes('present') || workSec > 0;
            if (isPresent) {
                monthlyPresentDays += 1;
            }
        });

        const sumWeeklyWork = weeklyTotals.reduce((a, b) => a + b, 0);
        const sumWeeklyBreak = weeklyBreakTotals.reduce((a, b) => a + b, 0);
        const sumWeekdayWork = weeklyWeekdayWork.reduce((a, b) => a + b, 0);
        return {
            monthly: { work: monthlyWork, break: monthlyBreak, presentDays: monthlyPresentDays },
            weekly: weeklyTotals,
            weeklyBreak: weeklyBreakTotals,
            weeklyDays,
            weeklyWeekdayWork,
            sumWeeklyWork,
            sumWeeklyBreak,
            sumWeekdayWork,
            weeklyDateRanges
        };
    };

    getModalUserInfo = () => {
        const { modalSelectedUser, modalSelectedMonthYear, modalAttendance, Attendance } = this.state;
        if (!modalSelectedUser) return { name: '', employeeId: '' };
        const source = modalSelectedMonthYear ? modalAttendance : Attendance;
        let row = Array.isArray(source) ? source.find(r => r && r.firstname === modalSelectedUser) : null;
        if (!row && Array.isArray(Attendance)) {
            row = Attendance.find(r => r && r.firstname === modalSelectedUser);
        }
        const employeeId = row && row.user_name ? row.user_name : '';
        return { name: modalSelectedUser, employeeId };
    };

    downloadModalPdf = async () => {
        const { modalSelectedMonthYear, selectedDate, modalUserStatistics } = this.state;
        const stats = this.computeUserMonthlyAndWeeklyTotals();
        const userInfo = this.getModalUserInfo();
        const selMY = modalSelectedMonthYear || selectedDate;
        const [y, m] = selMY.split('-');
        const monthName = new Date(`${y}-${m}-01T00:00:00`).toLocaleString('en-US', { month: 'long', year: 'numeric' });

        const doc = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });

        // Page geometry
        const pageWidth = (doc.internal.pageSize.getWidth && doc.internal.pageSize.getWidth()) || doc.internal.pageSize.width;
        const margin = 40;

        // Add company logo at top-left
        try {
            const base64Image = await this.getBase64ImageFromUrl(logo);
            if (base64Image) {
                const imgWidth = 70;
                const imgHeight = 50;
                const x = margin;
                const yImg = 20;
                doc.addImage(base64Image, 'PNG', x, yImg, imgWidth, imgHeight);
            }
        } catch (e) {
            console.warn('Logo image could not be loaded for PDF export:', e);
        }

        // Right-aligned title and month strings
        doc.setFontSize(16);
        doc.text('User Attendance Summary', pageWidth - margin, 40, { align: 'right' });
        doc.setFontSize(11);
        doc.setTextColor(100);
        doc.text(`${monthName}`, pageWidth - margin, 58, { align: 'right' });

        // User details table
        const userDetailsBody = [
            ['User', userInfo.name || '-'],
            ['Employee ID', userInfo.employeeId || '-'],
        ];
        autoTable(doc, {
            startY: 72,
            head: [['User Details', '']],
            body: userDetailsBody,
            styles: { fontSize: 10, cellPadding: 6 },
            headStyles: { fillColor: [247, 247, 249], textColor: 20, halign: 'left' },
            columnStyles: { 1: { halign: 'right' } },
            theme: 'grid',
        });

        // Find user statistics for the selected user
        const userStats = modalUserStatistics.find(stat => stat.firstname === userInfo.name) || {
            comes_late_count: 0,
            absent_count: 0,
            leave_count: 0,
            leave_days_count: 0,
            half_day_count: 0,
            present_count: 0,
            week_off_count: 0,
            holiday_count: 0,
            left_early_count: 0
        };

        // User statistics table (horizontal)
        const userStatsHeaders = ['Late', 'Absent/Leave', 'Half Day', 'Present', 'Week Off', 'Holiday', 'Left Early', 'Leave Days'];
        const absentLeaveCount = `${userStats.absent_count || 0}/${userStats.leave_count || 0}`;
        const userStatsCounts = [
            String(userStats.comes_late_count || 0),
            absentLeaveCount,
            String(userStats.half_day_count || 0),
            String(userStats.present_count || 0),
            String(userStats.week_off_count || 0),
            String(userStats.holiday_count || 0),
            String(userStats.left_early_count || 0),
            String(userStats.leave_days_count || 0)
        ];
        autoTable(doc, {
            startY: (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 12 : 120,
            head: [userStatsHeaders],
            body: [userStatsCounts],
            styles: { fontSize: 10, cellPadding: 6 },
            headStyles: { fillColor: [247, 247, 249], textColor: 20, halign: 'center' },
            columnStyles: Object.fromEntries(userStatsHeaders.map((_, index) => [index, { halign: 'center' }])),
            theme: 'grid',
        });

        // Monthly totals table
        const monthlyBody = [
            ['Work', this.formatSecondsToHoursText(stats.monthly.work)],
            ['Present Days', String(stats.monthly.presentDays)],
        ];

        // Add Leave Days if available
        if (userStats.leave_days_count && userStats.leave_days_count > 0) {
            monthlyBody.push(['Leave Days', String(userStats.leave_days_count)]);
        }
        autoTable(doc, {
            startY: (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 12 : 200,
            head: [['Monthly Totals', '']],
            body: monthlyBody,
            styles: { fontSize: 10, cellPadding: 6 },
            headStyles: { fillColor: [247, 247, 249], textColor: 20, halign: 'left' },
            columnStyles: { 1: { halign: 'right' } },
            theme: 'grid',
        });

        // Weekly totals table
        const weeklyHead = ['Week', 'Present Days', 'Total Hrs.'];
        const statsComputed = stats; // already computed above
        const weeklyBody = statsComputed.weeklyDateRanges.map((dateRange, i) => [
            `Week ${i + 1} (${dateRange || ''})`,
            String(statsComputed.weeklyDays[i] || 0),
            this.formatSecondsToHoursText(statsComputed.weeklyWeekdayWork[i] || 0),
        ]);
        weeklyBody.push([
            'Monthly Total Hrs.',
            '',
            this.formatSecondsToHoursText(statsComputed.sumWeekdayWork || 0),
        ]);
        autoTable(doc, {
            startY: (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 12 : 160,
            head: [weeklyHead],
            body: weeklyBody,
            styles: { fontSize: 10, cellPadding: 6 },
            headStyles: { fillColor: [247, 247, 249], textColor: 20, halign: 'left' },
            columnStyles: { 1: { halign: 'right' }, 2: { halign: 'right' } },
            theme: 'grid',
        });

        const fileName = `Attendance_${userInfo.name || 'user'}_${y}-${m}.pdf`;
        doc.save(fileName);
    };

    handlePageSizeChangeMonthly = (pageSize) => {
        this.setState({ pageSizeMonthly: pageSize });
    };

    handlePageSizeChangeDaily = (pageSize) => {
        this.setState({ pageSizeDaily: pageSize });
    };

    handleChangeDaily = (e) => {
        const searchQueryDaily = e.target.value.toLowerCase();
        const suggestionsDaily = this.state.dailyLogData.filter((item) => {
            return (
                item.date.includes(searchQueryDaily) ||
                item.firstname.toLowerCase().includes(searchQueryDaily) ||
                (item.user_name && item.user_name.toLowerCase().includes(searchQueryDaily)) ||
                (item.type && item.type.toLowerCase().includes(searchQueryDaily))
            );
        });
        this.setState({ searchQueryDaily, suggestionsDaily });
    };

    handleChangeMonthly = (e) => {
        const searchQueryMonthly = e.target.value.toLowerCase();
        const suggestionsMonthly = this.state.Attendance.filter((item) => {
            return (
                item.date.includes(searchQueryMonthly) ||
                item.firstname.toLowerCase().includes(searchQueryMonthly) ||
                (item.user_name && item.user_name.toLowerCase().includes(searchQueryMonthly)) ||
                (item.status && item.status.toLowerCase().includes(searchQueryMonthly))
            );
        });
        this.setState({ searchQueryMonthly, suggestionsMonthly });
    };

    handleSearchMonthly = () => {
        const { Attendance, searchQueryMonthly, selectedUser, selectedDate } = this.state;
        const [selectedYear, selectedMonth] = selectedDate.split('-');

        const filterEvents = Attendance.filter((item) => {
            const [, itemMonth, itemYear] = item.date.split('-');
            const matchesDateOrName =
                item.date.includes(searchQueryMonthly) ||
                item.firstname.toLowerCase().includes(searchQueryMonthly.toLowerCase()) ||
                (item.user_name && item.user_name.toLowerCase().includes(searchQueryMonthly.toLowerCase())) ||
                (item.status && item.status.toLowerCase().includes(searchQueryMonthly.toLowerCase()));
            const matchesUser = selectedUser ? item.firstname === selectedUser : true;
            const matchesMonthYear = itemYear === selectedYear && itemMonth === selectedMonth;
            return matchesDateOrName && matchesUser && matchesMonthYear;
        });
        this.setState({ filterEvents });
    };

    // Method to filter by selected user only (without search query)
    filterBySelectedUser = () => {
        const { Attendance, selectedUser, selectedDate } = this.state;
        const [selectedYear, selectedMonth] = selectedDate.split('-');

        const filterEvents = Attendance.filter((item) => {
            const [, itemMonth, itemYear] = item.date.split('-');
            const matchesUser = selectedUser ? item.firstname === selectedUser : true;
            const matchesMonthYear = itemYear === selectedYear && itemMonth === selectedMonth;
            return matchesUser && matchesMonthYear;
        });
        this.setState({ filterEvents });
    };

    handleSearchDaily = () => {
        const filterEventsDaily = this.state.dailyLogData.filter((item) => {
            return (
                item.date.includes(this.state.searchQueryDaily) ||
                item.firstname.toLowerCase().includes(this.state.searchQueryDaily.toLowerCase()) ||
                (item.user_name && item.user_name.toLowerCase().includes(this.state.searchQueryDaily.toLowerCase())) ||
                (item.type && item.type.toLowerCase().includes(this.state.searchQueryDaily.toLowerCase()))
            );
        });
        this.setState({ filterEventsDaily });
    };

    clearSearchMonthly = () => {
        this.setState({ searchQueryMonthly: "", suggestionsMonthly: [] }, this.handleSearchMonthly);
    };

    clearSearchDaily = () => {
        this.setState({ searchQueryDaily: "", suggestionsDaily: [] }, this.handleSearchDaily);
    };

    handleSuggestionClickMonthly = (suggestion) => {
        this.setState({ searchQueryMonthly: suggestion.firstname, suggestionsMonthly: [] }, this.handleSearchMonthly);
    };

    handleSuggestionClickDaily = (suggestion) => {
        this.setState({ searchQueryDaily: suggestion.firstname, suggestionsDaily: [] }, this.handleSearchDaily);
    };

    getBase64ImageFromUrl = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    // excel file download
    downloadAttendanceXLSX = async () => {
        const workbook = new ExcelJS.Workbook();
        const { selectedDate, Attendance, selectedUser, userStatistics } = this.state;
        const [year, month] = selectedDate.split('-');
        const reportType = `Attendance Report for ${month}-${year}`;

        // Get base64 image for logo
        let base64Image;
        try {
            base64Image = await this.getBase64ImageFromUrl(logo);
        } catch (e) {
            console.warn('Logo image could not be loaded for Excel export:', e);
        }

        const columnsFiltered = this.state.columns.filter(col => col.field !== 'firstName');
        const headers = columnsFiltered.map(col => col.headerName);
        const dateIndex = headers.indexOf('Date');
        headers.splice(dateIndex + 1, 0, 'Day');

        // Helper function to add user statistics summary
        const addUserStatisticsSummary = (worksheet, userStats, isAllUsers = false) => {

            // Add logo and header
            const fillColor = 'FFFFFF00';
            for (let row = 1; row <= 2; row++) {
                for (let col = 1; col <= 9; col++) {
                    const cell = worksheet.getCell(row, col);
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor }
                    };
                }
            }

            // Add logo to each worksheet
            if (base64Image) {
                try {
                    const currentImageId = workbook.addImage({
                        base64: base64Image.split(',')[1],
                        extension: 'png',
                    });
                    const columnWidth = worksheet.getColumn(1).width || 10;
                    const imageWidth = 50;
                    const startCol = (columnWidth - imageWidth / 7.5) / 6;
                    worksheet.addImage(currentImageId, {
                        tl: { col: startCol, row: 0 },
                        ext: { width: imageWidth, height: 40 }
                    });
                } catch (e) {
                    console.warn('Logo could not be added to worksheet:', e);
                }
            }

            worksheet.getCell('B1').value = `Cherrypik Software Attendance Report`;
            worksheet.getCell('B2').value = isAllUsers ? `${userStats.firstname} - ${reportType}` : reportType;
            worksheet.getCell('B3').font = { bold: true, size: 14 };

            // Add user statistics summary horizontally
            const statsStartRow = 4;
            worksheet.getCell(`A${statsStartRow}`).value = 'User Statistics Summary';
            worksheet.getCell(`A${statsStartRow}`).font = { bold: true, size: 12 };
            worksheet.getCell(`A${statsStartRow}`).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE6F3FF' }
            };

            // Statistics headers (horizontal)
            const statsHeaders = ['Late', 'Absent/Leave', 'Half Day', 'Present', 'Week Off', 'Holiday', 'Left Early', 'Leave Days'];
            const statsCounts = [
                userStats.comes_late_count || 0,
                `${userStats.absent_count || 0}/${userStats.leave_count || 0}`,
                userStats.half_day_count || 0,
                userStats.present_count || 0,
                userStats.week_off_count || 0,
                userStats.holiday_count || 0,
                userStats.left_early_count || 0,
                userStats.leave_days_count || 0
            ];

            // Add statistics headers row
            const headerRow = worksheet.addRow(statsHeaders);
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF4CAF50' },
                };
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            });

            // Add statistics counts row
            const countsRow = worksheet.addRow(statsCounts);
            countsRow.eachCell((cell) => {
                cell.alignment = { horizontal: 'center' };
                cell.font = { bold: true, size: 11 };
            });

            // Add empty row after statistics
            worksheet.addRow([]);

            return statsStartRow + 4; // Return the row where data should start
        };

        // Helper function to create a worksheet for a specific user
        const createUserWorksheet = (userData, userName, isAllUsers = false) => {
            const sheetName = isAllUsers ? userName.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 31) : 'Attendance';
            const worksheet = workbook.addWorksheet(sheetName);

            // Find user statistics
            const userStats = userStatistics.find(stat => stat.firstname === userName) || {
                comes_late_count: 0,
                absent_count: 0,
                leave_count: 0,
                leave_days_count: 0,
                half_day_count: 0,
                present_count: 0,
                week_off_count: 0,
                holiday_count: 0,
                left_early_count: 0,
                firstname: userName
            };

            // Add statistics summary and get the starting row for data
            const dataStartRow = addUserStatisticsSummary(worksheet, userStats, isAllUsers);

            // Add headers
            const headerRow = worksheet.addRow(headers);
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF00FF00' },
                };
                cell.font = { bold: true };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
            });

            // Add data rows
            if (userData.length === 0) {
                worksheet.getCell(`A${dataStartRow + 1}`).value = 'No Data Available';
                worksheet.mergeCells(`A${dataStartRow + 1}:I${dataStartRow + 1}`);
                worksheet.getCell(`A${dataStartRow + 1}`).alignment = { horizontal: 'center' };
            } else {
                userData.forEach(row => {
                    const rowData = columnsFiltered.map(col => row[col.field]);
                    const dateValue = row['date'];
                    let dayValue = '';
                    if (dateValue) {
                        const [day, month, year] = dateValue.split('-');
                        const jsDate = new Date(`${year}-${month}-${day}`);
                        dayValue = jsDate.toLocaleDateString('en-US', { weekday: 'long' });
                    }
                    rowData.splice(dateIndex + 1, 0, dayValue);
                    const addedRow = worksheet.addRow(rowData);

                    const statusColIndex = headers.indexOf('Status') + 1;
                    const statusValue = row['status'];
                    const statusColor = this.state.statusColors && this.state.statusColors[statusValue]
                        ? this.state.statusColors[statusValue].replace('#', '')
                        : '000000';

                    if (statusColIndex > 0) {
                        addedRow.getCell(statusColIndex).font = {
                            color: { argb: `FF${statusColor.toUpperCase()}` },
                            bold: true,
                        };
                    }
                });
            }

            // Set column widths
            worksheet.columns.forEach(column => {
                column.width = 20;
            });

            return worksheet;
        };

        // Check if we need to create multiple sheets (All Users selected)
        if (!selectedUser) {
            // Group attendance data by user
            const userGroups = {};
            Attendance.forEach(row => {
                const userName = row.firstname;
                if (!userGroups[userName]) {
                    userGroups[userName] = [];
                }
                userGroups[userName].push(row);
            });

            // Create a worksheet for each user
            Object.keys(userGroups).forEach(userName => {
                createUserWorksheet(userGroups[userName], userName, true);
            });

            // If no users found, create a default sheet
            if (Object.keys(userGroups).length === 0) {
                createUserWorksheet([], 'No Data');
            }
        } else {
            // Single user selected - create one sheet
            const userData = Attendance.filter(event => event.firstname === selectedUser);
            createUserWorksheet(userData, selectedUser);
        }

        // Generate filename
        const roles = ls.get("roles");
        const userName = ls.get("user").firstName + " " + ls.get("user").lastName;
        let fileName = '';

        if (roles && roles.includes("Super Admin")) {
            if (selectedUser) {
                fileName = `${selectedUser} Attendance ${month}-${year}.xlsx`;
            } else {
                fileName = `All Users Attendance ${month}-${year}.xlsx`;
            }
        } else {
            fileName = `${userName} Attendance ${month}-${year}.xlsx`;
        }

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
    };


    handleUserChange(event) {
        const selectedUser = event.target.value;
        this.setState({ selectedUser }, () => {
            if (selectedUser) {
                this.filterBySelectedUser();
            } else {
                // If no user selected, show all data
                this.setState({ filterEvents: this.state.Attendance });
            }
        });
    }


    render() {
        const { columns, Attendance, selectedDate, showMonthlyLog, selectedDatejh, dailyLogColumns, pageSizeMonthly, pageSizeDaily, searchQueryMonthly, searchQueryDaily, suggestionsMonthly, suggestionsDaily, selectedUser } = this.state;
        const roles = ls.get("roles");
        const roleList = Array.isArray(roles) ? roles : roles ? [roles] : [];
        const canSelectUser = roleList.includes("Super Admin") || roleList.includes("Admin");
        const filterEvents = this.state.filterEvents || this.state.Attendance;
        const filterEventsDaily = this.state.filterEventsDaily || this.state.dailyLogData;
        const uniqueUsers = [...new Set(Attendance.map(item => item.firstname))].sort((a, b) => a.localeCompare(b));
        const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark' || document.body.classList.contains('dark-theme');
        return (
            <div>
                <AuthCheckComponent authToken={this.props.authToken} />
                <Header
                    {...this.props}
                    authUser={this.props.authUser}
                    setAutUser={this.props.setAutUser}
                    component={
                        <div>
                            <Card style={{ marginBottom: '20px' }}>
                                <CardContent>
                                    <Breadcrumb
                                        {...this.props}
                                        primaryPageName="Attendance"
                                        isSecondaryPage={false}
                                        secondaryPageName="" />
                                </CardContent>
                            </Card>
                            <div
                                style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginInlineStart: "35px"
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    style={{
                                        marginRight: '10px',
                                        color: !showMonthlyLog ? '#f1ecec' : 'inherit',
                                        backgroundColor: !showMonthlyLog ? '#1b6e95' : 'inherit',
                                        textTransform: 'none'
                                    }}
                                    onClick={this.handleShowDailyLog}
                                >
                                    Daily Log
                                </Button>
                                <Button
                                    variant="outlined"
                                    style={{
                                        color: showMonthlyLog ? '#f1ecec' : 'inherit',
                                        backgroundColor: showMonthlyLog ? '#1b6e95' : 'inherit',
                                        textTransform: 'none'
                                    }}
                                    onClick={this.handleShowMonthlyLog}
                                >
                                    Monthly Log
                                </Button>
                            </div>
                            {/* monthly Attendance table */}
                            {showMonthlyLog ? (
                                <Card
                                    style={{
                                        padding: "20px",
                                        minHeight: "auto",       // Card height adjusts based on content
                                        height: "100%",
                                        overflow: "visible",
                                        marginBottom: "30px",     // Adds bottom spacing
                                        width: "98%",
                                        margin: "0 auto 30px auto"
                                    }}
                                >
                                    <div style={{ marginBottom: "20px" }}>
                                        {/* Filters Section */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px',
                                                marginBottom: '20px',
                                                marginTop: '5%'
                                            }}
                                        >
                                            {/* Select Month */}
                                            <TextField
                                                id="month"
                                                label="Select month"
                                                variant="outlined"
                                                type="month"
                                                value={selectedDate}
                                                onChange={this.handleDateChange}
                                                inputProps={{ max: this.getCurrentMonth() }}
                                                InputLabelProps={{ shrink: true }}
                                                style={{ minWidth: 180 }}
                                            />

                                            {/* Select User (admins only) */}
                                            {canSelectUser && (
                                                <TextField
                                                    select
                                                    label="Select User"
                                                    value={selectedUser}
                                                    onChange={this.handleUserChange}
                                                    variant="outlined"
                                                    style={{ minWidth: 200 }}
                                                    SelectProps={{
                                                        displayEmpty: true,
                                                        renderValue: (value) => (value ? value : 'All Users'),
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                >
                                                    <MenuItem value="">All Users</MenuItem>
                                                    {uniqueUsers.map((user, index) => (
                                                        <MenuItem key={index} value={user}>
                                                            {user}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            )}
                                        </div>

                                        {/* Filter and Search */}
                                        <div
                                            style={{
                                                position: "absolute",
                                                right: "67px",
                                                marginTop: "-60px",
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}
                                        >
                                            <IconButton
                                                onClick={this.openUserStatsModal}
                                                title="Filter Total Hours"
                                                style={{
                                                    backgroundColor: '#1b6e95',
                                                    color: '#ffffff',
                                                    borderRadius: 6,
                                                    width: 48,
                                                    height: 40
                                                }}
                                            >
                                                <FilterListIcon htmlColor="#ffffff" />
                                            </IconButton>



                                            <TextField
                                                label="Search"
                                                value={searchQueryMonthly}
                                                onChange={this.handleChangeMonthly}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: searchQueryMonthly !== "",
                                                    style: {
                                                        color: '#1b6e95',
                                                        transform: searchQueryMonthly !== ""
                                                            ? 'translate(14px, -6px) scale(0.75)'
                                                            : 'translate(14px, 11px) scale(1)',
                                                        transition: 'transform 0.2s ease-in-out'
                                                    }
                                                }}
                                                InputProps={{
                                                    style: {
                                                        backgroundColor: 'lightgray',
                                                        borderRadius: '25px',
                                                        height: "40px"
                                                    },
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {searchQueryMonthly && (
                                                                <ClearIcon
                                                                    onClick={this.clearSearchMonthly}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            )}
                                                            <SearchIcon
                                                                onClick={this.handleSearchMonthly}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </div>

                                        {/* Suggestions */}
                                        {searchQueryMonthly && suggestionsMonthly.length > 0 && (
                                            <Paper
                                                style={{
                                                    position: 'absolute',
                                                    right: '130px',
                                                    marginTop: '-20px',
                                                    zIndex: 1,
                                                    width: "213px",
                                                    maxHeight: '200px',
                                                    overflowY: 'auto',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                                                }}
                                            >
                                                {[...new Set(
                                                    suggestionsMonthly
                                                        .flatMap(suggestion => [suggestion.firstname, suggestion.user_name, suggestion.status])
                                                        .filter(Boolean)
                                                        .filter(value => value.toLowerCase().includes(searchQueryMonthly))
                                                )].map((value, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        onClick={() => this.setState({ searchQueryMonthly: value }, this.handleSearchMonthly)}
                                                    >
                                                        {value}
                                                    </MenuItem>
                                                ))}
                                            </Paper>
                                        )}

                                        {/* Data Grid */}
                                        <div style={{ width: '100%', marginTop: "40px" }}>
                                            <DataGrid
                                                columns={columns}
                                                rows={filterEvents}
                                                page={this.state.pageMonthly}
                                                pageSize={pageSizeMonthly}
                                                rowsPerPageOptions={[5, 10, 25, 100]}
                                                onPageChange={(newPage) => this.setState({ pageMonthly: newPage })}
                                                onPageSizeChange={(newPageSize) => this.handlePageSizeChangeMonthly(newPageSize)}
                                                disableRowSelectionOnClick
                                                hideFooter
                                                autoHeight
                                            />
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <TablePagination
                                                component="div"
                                                count={filterEvents.length}
                                                page={this.state.pageMonthly}
                                                onPageChange={this.handlePageChangeMonthly}
                                                rowsPerPage={pageSizeMonthly}
                                                onRowsPerPageChange={(e) => {
                                                    this.handlePageSizeChangeMonthly(parseInt(e.target.value, 10));
                                                    this.setState({ pageMonthly: 0 });
                                                }}
                                                rowsPerPageOptions={[5, 10, 25, 100]}
                                                style={{ color: isDarkMode ? '#ffffff' : 'inherit', borderBottom: 'none', width: 'fit-content' }}
                                                ActionsComponent={TablePaginationActions}
                                            />
                                        </div>

                                        {/* Download Button */}
                                        <Grid
                                            item xs={3}
                                            style={{
                                                marginTop: "30px",
                                                marginBottom: "20px",
                                                display: "flex",
                                                justifyContent: "flex-start"
                                            }}
                                        >
                                            <ExportButton
                                                label="Download Attendance Xlsx"
                                                onClick={this.downloadAttendanceXLSX}
                                            />
                                        </Grid>
                                    </div>
                                </Card>

                            ) : (

                                // dayly Attendance table 
                                <Card style={{ padding: "10px", width: "98%", margin: "0 auto" }}>
                                    <div style={{ paddingBottom: "50px" }}>
                                        <div style={{ marginBottom: '20px', textAlign: 'right' }}>
                                            <TextField
                                                id="date"
                                                label="Select date"
                                                variant="outlined"
                                                type="date"
                                                value={selectedDatejh}
                                                onChange={this.handledayChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                style={{ marginRight: '10px' }}
                                            />
                                        </div>
                                        <div className='graphresponsive'>
                                            <canvas
                                                ref={this.chartRef}
                                                style={{
                                                    height: '400px',
                                                    width: '100%'
                                                }}
                                            />
                                        </div>
                                        <TextField
                                            label="Search"
                                            value={searchQueryDaily}
                                            onChange={this.handleChangeDaily}
                                            style={{
                                                position: "absolute",
                                                right: "67px",
                                                marginTop: "15px"
                                            }}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: searchQueryDaily !== "",
                                                style: {
                                                    color: '#1b6e95',
                                                    transform: searchQueryDaily !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                                                    transition: 'transform 0.2s ease-in-out'
                                                }
                                            }}
                                            InputProps={{
                                                style: {
                                                    backgroundColor: 'lightgray',
                                                    borderRadius: '25px',
                                                    height: "40px"
                                                },
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {searchQueryDaily && (
                                                            <ClearIcon onClick={this.clearSearchDaily} style={{ cursor: 'pointer' }} />
                                                        )}
                                                        <SearchIcon onClick={this.handleSearchDaily} style={{ cursor: 'pointer' }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {searchQueryDaily && suggestionsDaily.length > 0 && (
                                            <Paper style={{
                                                position: 'absolute', right: '130px', marginTop: '62px', zIndex: 1, width: "209px", maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                                            }}>
                                                {[...new Set(
                                                    suggestionsDaily
                                                        .flatMap(suggestion => [suggestion.firstname, suggestion.user_name, suggestion.type])
                                                        .filter(Boolean)
                                                        .filter(value => value.toLowerCase().includes(searchQueryDaily))
                                                )].map((value, index) => (
                                                    <MenuItem key={index} onClick={() => this.setState({ searchQueryDaily: value }, this.handleSearchDaily)}>
                                                        {value}
                                                    </MenuItem>
                                                ))}
                                            </Paper>
                                        )}
                                        <div style={{ width: '100%', marginTop: "77px", marginBottom: "25px" }}>
                                            <DataGrid
                                                rows={filterEventsDaily}
                                                columns={dailyLogColumns}
                                                page={this.state.pageDaily}
                                                pageSize={pageSizeDaily}
                                                rowsPerPageOptions={[5, 10, 25, 100]}
                                                onPageChange={(newPage) => this.setState({ pageDaily: newPage })}
                                                onPageSizeChange={(newPageSize) => this.handlePageSizeChangeDaily(newPageSize)}
                                                disableRowSelectionOnClick
                                                hideFooter
                                                autoHeight={true}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <TablePagination
                                                component="div"
                                                count={filterEventsDaily.length}
                                                page={this.state.pageDaily}
                                                onPageChange={this.handlePageChangeDaily}
                                                rowsPerPage={pageSizeDaily}
                                                onRowsPerPageChange={(e) => {
                                                    this.handlePageSizeChangeDaily(parseInt(e.target.value, 10));
                                                    this.setState({ pageDaily: 0 });
                                                }}
                                                rowsPerPageOptions={[5, 10, 25, 100]}
                                                style={{ color: isDarkMode ? '#ffffff' : 'inherit', borderBottom: 'none', width: 'fit-content' }}
                                                ActionsComponent={TablePaginationActions}
                                            />
                                        </div>
                                    </div>
                                </Card>
                            )}
                            <Dialog open={this.state.isUserStatsOpen} onClose={this.closeUserStatsModal} fullWidth maxWidth="sm">
                                <DialogTitle>
                                    <Typography variant="h6" style={{ fontWeight: 600 }}>User Filter & Summary</Typography>
                                </DialogTitle>
                                <DialogContent>
                                    <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' }}>

                                        <TextField
                                            id="modal-month"
                                            label="Select month"
                                            variant="outlined"
                                            type="month"
                                            value={this.state.modalSelectedMonthYear}
                                            onChange={this.handleModalMonthChange}
                                            inputProps={{ max: this.getCurrentMonth() }}
                                            InputLabelProps={{ shrink: true }}
                                            style={{ minWidth: 200 }}
                                        />
                                        {(ls.get("roles") && ls.get("roles").includes("Super Admin")) ? (
                                            <TextField
                                                select
                                                label="Select User"
                                                value={this.state.modalSelectedUser}
                                                onChange={this.handleModalUserChange}
                                                variant="outlined"
                                                style={{ minWidth: 240 }}
                                            >
                                                <MenuItem value="">
                                                    <em>Choose User</em>
                                                </MenuItem>
                                                {uniqueUsers.map((user, index) => (
                                                    <MenuItem key={index} value={user}>
                                                        {user}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        ) : (
                                            <TextField
                                                label="User"
                                                value={this.state.modalSelectedUser}
                                                variant="outlined"
                                                disabled
                                                style={{ minWidth: 240 }}
                                            />
                                        )}
                                    </div>
                                    {this.state.modalSelectedUser ? (() => {
                                        const stats = this.computeUserMonthlyAndWeeklyTotals();
                                        const userInfo = this.getModalUserInfo();
                                        const selMY = this.state.modalSelectedMonthYear || this.state.selectedDate;
                                        let monthShort = '';
                                        if (selMY && selMY.includes('-')) {
                                            const [y, m] = selMY.split('-');
                                            const dt = new Date(`${y}-${m}-01T00:00:00`);
                                            monthShort = dt.toLocaleString('en-US', { month: 'short' });
                                        }
                                        return (
                                            <div>
                                                <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                                                    <TableContainer component={Paper} style={{ borderRadius: 8, flex: 1, minWidth: 260 }}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell colSpan={2} style={{ fontWeight: 700, backgroundColor: '#1b6e95', color: '#ffffff' }}>User Details</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell>User</TableCell>
                                                                    <TableCell>{userInfo.name || '-'}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Employee ID</TableCell>
                                                                    <TableCell>{userInfo.employeeId || '-'}</TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TableContainer component={Paper} style={{ borderRadius: 8, flex: 1, minWidth: 260 }}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell colSpan={2} style={{ fontWeight: 700, backgroundColor: '#1b6e95', color: '#ffffff' }}>Monthly Totals</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell>Work</TableCell>
                                                                    <TableCell style={{ textAlign: 'left', fontWeight: 600 }}>{this.formatSecondsToHoursText(stats.monthly.work)}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell>Present Days</TableCell>
                                                                    <TableCell style={{ textAlign: 'left' }}>{stats.monthly.presentDays}</TableCell>
                                                                </TableRow>
                                                                {(() => {
                                                                    const userStats = this.state.modalUserStatistics.find(stat => stat.firstname === this.state.modalSelectedUser);
                                                                    const leaveDays = userStats && userStats.leave_days_count ? userStats.leave_days_count : 0;
                                                                    return leaveDays > 0 ? (
                                                                        <TableRow>
                                                                            <TableCell>Leave Days</TableCell>
                                                                            <TableCell style={{ textAlign: 'left' }}>{leaveDays}</TableCell>
                                                                        </TableRow>
                                                                    ) : null;
                                                                })()}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                                <Divider style={{ margin: '16px 0' }} />

                                                <TableContainer component={Paper} style={{ marginTop: 12, borderRadius: 8 }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow style={{ backgroundColor: '#1b6e95' }}>
                                                                <TableCell style={{ fontWeight: 700, color: '#ffffff', padding: '4px 8px' }}>Week</TableCell>
                                                                {/* <TableCell style={{ fontWeight: 700, textAlign: 'right' }}>Break</TableCell> */}
                                                                <TableCell style={{ fontWeight: 700, textAlign: 'center', color: '#ffffff', padding: '4px 8px' }}>Present Days</TableCell>
                                                                <TableCell style={{ fontWeight: 700, textAlign: 'center', color: '#ffffff', padding: '4px 8px' }}>Total Hrs.</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {stats.weeklyDateRanges.map((dateRange, week) => (
                                                                <TableRow key={week} style={{ background: week % 2 === 0 ? '#ffffff' : '#fafafa' }}>
                                                                    <TableCell style={{ padding: '4px 8px' }}>
                                                                        <div>
                                                                            <div style={{ fontWeight: 600 }}>Week {week + 1}</div>
                                                                            <div style={{ fontSize: '0.8em', color: '#666', marginTop: '2px' }}>
                                                                                {dateRange || ''}
                                                                            </div>
                                                                        </div>
                                                                    </TableCell>
                                                                    {/* <TableCell style={{ textAlign: 'right' }}>{this.formatSecondsToHoursText(stats.weeklyBreak[week])}</TableCell> */}
                                                                    <TableCell style={{ textAlign: 'center', padding: '4px 8px' }}>{stats.weeklyDays[week]}</TableCell>
                                                                    <TableCell style={{ textAlign: 'center', padding: '4px 8px' }}>{this.formatSecondsToHoursText(stats.weeklyWeekdayWork[week])}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow>
                                                                <TableCell style={{ fontWeight: 700, padding: '4px 8px' }}>Monthly Total Hrs.{monthShort ? ` (${monthShort})` : ''}</TableCell>

                                                                <TableCell></TableCell>
                                                                <TableCell style={{ fontWeight: 700, textAlign: 'center', padding: '4px 8px' }}>{this.formatSecondsToHoursText(stats.sumWeekdayWork)}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        );
                                    })() : (
                                        <div>Please select a user to view totals.</div>
                                    )}
                                </DialogContent>
                                <DialogActions>
                                    <IconButton
                                        aria-label="download"
                                        title="Download PDF"
                                        onClick={this.downloadModalPdf}
                                        disabled={!this.state.modalSelectedUser}
                                        style={{
                                            opacity: this.state.modalSelectedUser ? 1 : 0.5,
                                            cursor: this.state.modalSelectedUser ? 'pointer' : 'not-allowed'
                                        }}
                                    >
                                        <GetAppIcon />
                                    </IconButton>
                                    <Button onClick={this.closeUserStatsModal} color="primary" variant="contained" style={{ textTransform: 'none' }}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    }
                />
                <Footer {...this.props} />
            </div>
        );
    }
}

export default Attendance;
